/**
 * Created by WebStorm.
 * User: liulin
 * Date: 2018/11/8
 * Time: 7:29 PM
 */
export function getUUID () {
  return 'xxxx-xxxx-xxxx-xxxx-xxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16 | 0
    let v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}



// WEBPACK FOOTER //
// ./src/common/util/index.js